import { render } from "./DateSelectCalendarSimple.vue?vue&type=template&id=6c245938&scoped=true"
import script from "./DateSelectCalendarSimple.vue?vue&type=script&lang=js"
export * from "./DateSelectCalendarSimple.vue?vue&type=script&lang=js"

import "./DateSelectCalendarSimple.vue?vue&type=style&index=0&id=6c245938&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c245938"]])

export default __exports__